// Every standard contact field is carried to the server by a hidden input in `#cfAR`, and
// `getContactForm` (submit.ts) resolves that input by an id built from the page input's own `name`.
// One carrier's id does not follow the rule: the Phone input renders `name="phone_number"`, but its
// carrier is `#cf_contact_phone` (`contact[phone_number]`). Without this map the lookup misses, the
// phone is treated as a custom attribute and posted as a bare top-level `phone_number` param.
// The only server code that reads that bare param is the `checkout_params` fallback in
// `ContactConcern#find_create_or_merge_contact`, so an opt-in that also carried an email still
// saved its phone. A phone-only opt-in never got that far: with no `contact[...]` key at all,
// `missing_contact_params?` short-circuited the request, the number landed in
// `form_submissions.data` and nowhere else, and `contacts.phone_number` stayed blank (ENG-7661).
// Checkout is unaffected because it serializes off `data-cf-form-field` instead.

// Keyed by the input's `name`, valued by the carrier id's suffix. Names absent here use the
// `cf_contact_<name>` id directly, so CF Classic pages still emitting `name="phone"` keep resolving
// to the same carrier they always have. A Map rather than an object literal: `name` is customer
// data, and an object lookup of a custom field called `constructor` or `toString` would reach the
// prototype and build a selector that throws out of the whole submit.
const CONTACT_CARRIER_ID_SUFFIXES = new Map<string, string>([['phone_number', 'phone']])

export function contactCarrierInputId(name: string): string {
  return `cf_contact_${CONTACT_CARRIER_ID_SUFFIXES.get(name) ?? name}`
}
